import React, { Component } from "react";
import { alertActions } from '../../action/AlertAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { history } from '../../helpers/history';
import { accountActions } from '../../action/AccountAction';
import { gameActions } from "../../action/GameAction";
import { Helmet } from "react-helmet";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from 'moment';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { commonClass } from "../../helpers/commonClass";

class Order extends Component {

    constructor(props) {
        super(props);
        this.state = {
            serverDate: new Date(),
            startDate: moment().subtract(29, 'days'),
            endDate: moment(),
            currentPageNo: 0,
            NumberofRecord: 5,
            totalPage: 0,
            startinx: 0,
            endinx: 10,
            lfilterdt: [],
            rebetNumbers: {}, // key: transactionID, value: array of numbers
            hoverTransactionID: null,
            SelectGame: 0

        }
    }
    static getDerivedStateFromProps(props, state) {
        return {
            OrderData: props.OrderData && props.OrderData.result && props.OrderData.result.map(function (ele) {
                return { ...ele, game_group_id_temp: ele.game_group_id == 12 || ele.game_group_id == 8 ? 1 : ele.game_group_id };
            })
        };
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.OrderData !== prevProps.OrderData || this.state.NumberofRecord !== prevState.NumberofRecord) {
            this.LoadTransactionData();
        }
    }

    LoadTransactionData = () => {
        if (this.props.OrderData && this.props.OrderData.result && this.props.OrderData.result.length > 0) {
            let ldt = []
            if (this.state.SelectGame != "0") {
                ldt = this.props.OrderData.result.filter(filterData => {
                    // Only Filterd Lotto
                    // if (this.state.SelectGame >= '1' && this.state.SelectGame <= '6') {
                    //     return filterData.game_group_id == this.state.SelectGame
                    // }
                    // // Only Other Slots
                    // else {
                    return filterData.game_group_id == this.state.SelectGame
                    // }
                });
            }
            // All Data
            else {
                ldt = this.props.OrderData.result;
            }

            this.setState({ lfilterdt: ldt });
            let ltotpage = Math.trunc(ldt.length / this.state.NumberofRecord);
            let ltotpage1 = Math.trunc(ldt.length % this.state.NumberofRecord);
            if (ltotpage1 == 0) {
                ltotpage = ltotpage - 1;
            }
            this.setState({ currentPageNo: 0 });
            this.setState({ totalPage: ltotpage })
            this.setState({ startinx: 0, endinx: this.state.NumberofRecord });
        }
        else {
            this.setState({ lfilterdt: [] });
        }
    }

    loadnxtdata = (st) => {
        debugger
        if (st == "+") {
            if (this.state.currentPageNo != this.state.totalPage) {
                this.state.currentPageNo = this.state.currentPageNo + 1;
            }
        }
        else if (st == "-") {
            if (this.state.currentPageNo != 0) {
                this.state.currentPageNo = this.state.currentPageNo - 1;
            }
        }
        else if (st == "first") {
            this.state.currentPageNo = 0;
        }
        else if (st == "last") {
            this.state.currentPageNo = this.state.totalPage;
        }
        let _startinx = this.state.currentPageNo * this.state.NumberofRecord;
        let _endinx = _startinx + this.state.NumberofRecord;
        this.setState({ startinx: _startinx, endinx: _endinx });
    }

    handleCallback = (start, end) => {
        if (start && end) {
            this.setState(
                {
                    startDate: start.format('DD/MM/YYYY'),
                    endDate: end.format('DD/MM/YYYY'),
                },
                () => {
                    this.onchangeNewDate(this.state.startDate, this.state.endDate);
                }
            );
        }
    };


    componentDidMount() {
        window.documentReadyjQueryFlex();
        this.handleCallback(this.state.startDate, this.state.endDate)
        // window.Loaddaterange(1);
        // var lstrdate = document.getElementById('mydaterange').value;
        // this.onchangeDate(lstrdate);
        // window.getdateFromJS(this.onchangeDate);
        // localStorage.setItem('atabId', 2); this code is using in Account Component
    }
    viewTicket = (transactionID) => {
        this.props.ViewTicket(transactionID, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
    }
    gotoReBet = (game_group_id, transactionID) => {
        this.props.GetReBetNumbers(game_group_id, transactionID, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
    }
    onchangeNewDate = (startDate, endDate) => {
        let checkdate = this.validatedate(startDate, endDate);
        if (checkdate) {
            // this.props.GetTransactiondel(this.state.rdoStatus, fdate, tdate, 1, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
            this.props.GetOrderDel(0, startDate, endDate, 1, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
        }
    }
    validatedate = (fromDate, toDate) => {
        let datepattern = /(\d{2})\/(\d{2})\/(\d{4})/;
        var fr = (new Date(fromDate.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));
        var to = (new Date(toDate.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));
        var currDate = ("0" + this.state.serverDate.getDate()).slice(-2) + "/" + ("0" + (this.state.serverDate.getMonth() + 1)).slice(-2) + "/" + this.state.serverDate.getFullYear();
        var lserverDate = (new Date(currDate.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));
        if (fr > lserverDate || to > lserverDate) {
            this.showMsg('lblNoFuturedate');
            return false;
        }
        return true;
        if (fr > to) {
            this.showMsg('lblFromdateNotGreater');
            return false;
        }
        fr.setHours(0, 0, 0, 0);
        to.setHours(0, 0, 0, 0);
        if (fr > to || fr < to) {
            var date = this.state.serverDate;
            var ss = ("0" + date.getDate()).slice(-2) + "/" + ("0" + (date.getMonth() + 1)).slice(-2) + "/" + date.getFullYear();
            var cdate = new Date(new Date(ss.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));
            var lfr = ("0" + fr.getDate()).slice(-2) + "/" + ("0" + (fr.getMonth() + 1)).slice(-2) + "/" + fr.getFullYear();
            var lto = ("0" + to.getDate()).slice(-2) + "/" + ("0" + (to.getMonth() + 1)).slice(-2) + "/" + to.getFullYear();
            var fdate = new Date(new Date(lfr.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));
            var tdate = new Date(new Date(lto.replace(datepattern, '$3-$2-$1').replace(/-/g, '/')));
            cdate.setHours(0, 0, 0, 0);
            fdate.setHours(0, 0, 0, 0);
            tdate.setHours(0, 0, 0, 0);
            if (fdate > cdate && tdate > cdate) {
                this.showMsg('lblCurrentDate');
                return false;
            }
        }
        return true;
    }
    showMsg = (lstrError) => {
        this.props.alertError(this.props.t(lstrError));
    }


    chkbtnClick = (event) => {
        setTimeout(() => {
            this.LoadTransactionData()
        }, 300);
    }

    setFilterbyGame = (event) => {
        this.setState({ SelectGame: event.target.value })
    }

    SetDefaulf = () => {
        this.setState({ SelectGame: '0' })
    }


    RefreshData = () => {
        // this.setState({ SelectGame: "0" })
        // this.state.SelectGame = "0";
        // this.chkbtnClick();
        // this.SetDefaulf();
        window.location.reload(true);
    }

    handleChange = (event) => {
        let newLimit = event.target.value == '0' ? this.state.OrderData.length : event.target.value;
        this.setState({ NumberofRecord: parseInt(newLimit) });
    };

    render() {
        const { t } = this.props;
        let Alloption = [
            { "name": "All", "id": "0" },
            { "name": "Play Lotto", "id": "1" },
            { "name": "Mini Lotto", "id": "2" },
            { "name": "Fast Lotto", "id": "3" },
            { "name": "Millionaire Lotto", "id": "4" },
            { "name": "Multi Million Lotto", "id": "5" },
            { "name": "Super Mega Million Lotto", "id": "6" },
            { "name": "Slots", "id": "7" },
            { "name": "Scratch", "id": "9" },
            { "name": "Roulette", "id": "40" },
            { "name": "Instant  Roulette", "id": "10" },
            { "name": "Poker", "id": "11" },
        ]
        return (
            <>
                {
                    process.env.REACT_APP_MODE != "development" && <Helmet>
                        <title>Gulf Ticket : Order</title>
                        <meta name="description" content="Gulf Ticket Order" />
                    </Helmet>
                }
                <div class="myAccContHead">
                    <h1><img src="./assets/img/icons/tabs-orders.png" />{t('lblOrders')}</h1>
                </div>

                <div class="orders">
                    <div class="filters">
                        <div class="filtersCont">
                            <div>
                                <label>{t('lblGameName')}</label>
                                <select class="custom-select" onChange={this.setFilterbyGame}>
                                    <option value="" disabled>{t('lblSel')}</option>
                                    {Alloption.map((option) => (
                                        <option key={option.id} value={option.id} >
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <span>
                                <label>{t('lblsearchdate')}</label>
                                {/* <input class="custDate" id="datepicker" type="text" placeholder="Start Date - End Date" /> */}
                                <DateRangePicker
                                    initialSettings={{
                                        startDate: this.state.startDate,
                                        endDate: this.state.endDate,
                                        locale: {
                                            format: 'DD/MM/YYYY',
                                            separator: ' - ',
                                            applyLabel: 'Apply',
                                            cancelLabel: 'Cancel',
                                        },
                                    }} onCallback={this.handleCallback}
                                >
                                    <input id='datepicker1' value={`${this.state.startDate} - ${this.state.endDate}`} readOnly />
                                </DateRangePicker>

                            </span>
                        </div>
                        <div class="filtersBtn">
                            <a onClick={() => { this.chkbtnClick() }}>{t('lblapply')}</a>
                            <a onClick={() => { this.RefreshData() }}><img src="./assets/img/icons/refresh.png" /></a>
                        </div>
                    </div>
                    <div class="table margin-top-20">
                        {this.state.OrderData && this.state.OrderData.length > 0 &&
                            <>
                                <ul class="transTble">
                                    <li>
                                        <div class="w-5 text-center">{t('lblserielNo')}</div>
                                        <div class="w-25">{t('lblGameName')}</div>
                                        <div class="w-15">{t('lbldate')}</div>
                                        <div class="w-15">{t('lblorderno')}</div>
                                        <div class="w-20">{t('lblTicket')}</div>
                                        {/* <div class="w-10 text-center" style={{ textTransform: "lowercase" }}>{t('lblQuantity')}</div> */}
                                        <div class="w-10 text-right">Rebet</div>
                                        <div class="w-10 text-right" style={{ textTransform: "lowercase" }}>{t('lblAmt')}</div>
                                    </li>
                                    {/* {this.state.OrderData.filter(fdata => ).map((data, index) => { */}
                                    {this.state.lfilterdt && this.state.lfilterdt.length > 0 && this.state.lfilterdt.slice(this.state.startinx, this.state.endinx).map((data, index) =>
                                        <li key={`bk_${index}`}>
                                            <div class="w-5 text-center">{index + 1}</div>
                                            <div class="w-25">{data.game_name}</div>
                                            <div class="w-15">{data.transaction_date_time}</div>
                                            <div class="w-15">{data.transaction_id}</div>
                                            {data.game_group_id != 7 && data.game_group_id != 8 && data.game_group_id != 9
                                                && data.game_group_id != 11 ?
                                                <div class="w-20" onClick={() => this.viewTicket(data.transaction_id)}>{t('lblTicket')} - {(data.play_type > 1) ? `${t('lblMulti')}` : `${t('lblsingle')}`} <img class="detailsIcon" src="./assets/img/icons/details.png" /></div>
                                                : <div class="w-20">-</div>
                                                // <div class="w-10" onMouseEnter={() => this.handleMouseEnter(data.transaction_id, data.game_group_id)}
                                                //     onMouseLeave={this.handleMouseLeave}>{t('lblTicket')} - 1
                                                //     <img class="detailsIcon" src="./assets/img/icons/details.png" />
                                                //     <div class="ticketInfoSec" >
                                                //         {
                                                //             this.state.hoverTransactionID === data.transaction_id &&
                                                //             this.state.rebetNumbers[data.transaction_id] &&
                                                //             <>
                                                //                 {this.state.rebetNumbers[data.transaction_id].split('|').map((ballNo, idx) => (
                                                //                     <div className="ticketInfoBall">
                                                //                         {ballNo.split(';').map((ballNo, idx) => (
                                                //                             <div key={`ball_${idx}`} className={`lottoInfoBall lto-${data.game_group_id}-border lto-${data.game_group_id}-active`}>
                                                //                                 {ballNo}
                                                //                             </div>
                                                //                         ))}
                                                //                     </div>
                                                //                 ))}
                                                //             </>
                                                //         }
                                                //         {data.bet_info && data.bet_info.split(';').length > 0 && data.bet_info.split(';').map((ballNo, inx) =>
                                                //             <div key={`bl_${inx}`} className={`lottoInfoBall lto-${data.game_group_id}-border lto-${data.game_group_id}-active`}>{ballNo}</div>
                                                //         )}
                                                //     </div>
                                                // </div>
                                            }
                                            {/* <div class="w-10 text-center">1</div> */}
                                            {data.game_group_id <= 6 && data.game_group_id >= 1 ? <div class="w-10 text-center" ><button onClick={() => this.gotoReBet(data.game_group_id, data.transaction_id)} class="reBetBtn">Rebet</button></div>
                                                : <div class="w-10 text-center">-</div>}
                                            <div class="w-10 text-right">{this.props.appvariables.currency} {commonClass.aedCrnyConvert(data.amount)}</div>
                                            {/* <div class="w-10 text-right">AED 100</div> */}

                                            {/* <div className="ordersCont">
                                            <div className="ordersSelect">
                                                <div className="orderTicket">
                                                    <div className="col-lg-3">
                                                        <span className="">
                                                            {data.game_group_id == 1 ?
                                                                <img src="./assets/img/gamesBg/fortune-6-logo.png?v0.2" alt="Fortune 6 logo" className="h-10 w-24" /> :
                                                                data.game_group_id == 2 ? <img src="./assets/img/gamesBg/super-6-logo.png?v0.2" alt="super 6 logo" className="h-10 w-24" /> :
                                                                    data.game_group_id == 3 ? <img src="./assets/img/gamesBg/magic-5-logo.png?v0.2" alt="magic 5 logo" className="h-10 w-24" />
                                                                        : data.game_group_id == 4 ? <img src="./assets/img/gamesBg/lucky-1-logo.png" alt="magic 5 logo" className="h-10 w-24" />
                                                                            : data.game_group_id == 5 ? <img src="./assets/img/gamesBg/dream-5-logo.png?v0.1" alt="dream 5 logo" className="h-10 w-24" /> :
                                                                                data.game_group_id == 6 ? <img src="./assets/img/gamesBg/pick-3-logo.png?v0.4" alt="dream 5 logo" className="h-10 w-24" /> :
                                                                                    (data.game_group_id == 7 || data.game_group_id == 8) ? <img src="./assets/img/gamesBg/slot-logo.png?v0.4" alt="fortune 4 logo" className="h-10 w-24" /> :
                                                                                        <img src="./assets/img/gamesBg/fortune-5-logo.png?v0.1" alt="fortune 5  logo" className="h-10 w-24" />}
                                                        </span>
                                                        {data.game_group_id == 7 || data.game_group_id == 8 ? <small>Amount : {data.amount}</small>
                                                            : <small>{t('lblPlayType')}: {(data.play_type > 1) ? `${t('lblMulti')}` : `${t('lblsingle')}`}</small>}
                                                        <small>{t('lblDrawDate')}: {data.draw_date_time}</small>
                                                        <small>{t('lblSubmitted')}: {data.transaction_date_time}</small>
                                                    </div>
                                                    {(data.game_group_id != 7 && data.game_group_id != 8) && <div className="col-lg-5 ordersCenter">
                                                        <div className={`orderBall border-game${data.game_group_id}`}>
                                                            {data.bet_info && data.bet_info.split(';').length > 0 && data.bet_info.split(';').map((ballNo, inx) =>
                                                                <span key={`bl_${inx}`} className={`bg-game${data.game_group_id_temp}`}>{ballNo}</span>
                                                            )}
                                                        </div>
                                                        {data.raffle_id != "" && data.raffle_id.length > 2 && <span className={`orderId border-game${data.game_group_id_temp}`}>{t('lblRafflaID')}: {data.raffle_id}</span>}
                                                    </div>}
                                                    {data.game_group_id != 7 && data.game_group_id != 8 && <div className="col-md-4">
                                                        <button className={`bg-game${data.game_group_id_temp}  ${data.game_group_id_temp != 2 ? `!border-game${data.game_group_id_temp} !` : ''}text-white hover:!bg-white hover:!text-[#494949]`} onClick={() => this.gotoReBet(data.game_group_id, data.transaction_id)}>{t('lblBuyAgain')}</button>
                                                        <button className={`${data.game_group_id_temp != 2 ? `bg-game${data.game_group_id_temp}` : ""} ${data.game_group_id_temp != 2 ? "viewTicket" : ""} ${`border-game${data.game_group_id_temp}`}`} onClick={() => this.viewTicket(data.transaction_id)}>{t('lblViewTickets')}</button>
                                                    </div>}
                                                </div>
                                            </div>
                                        </div> */}
                                        </li>
                                    )
                                    }
                                </ul>
                                <div class="pagination">
                                    <div class="paginationLft">
                                        {t('lblshowing')} <span>{this.state.currentPageNo + 1}</span> {t('lblto')} <span>{this.state.OrderData && Math.ceil(this.state.OrderData.length / this.state.NumberofRecord)}</span> {t('lblof')} <span>{this.state.OrderData.length}</span> {t('lblentries')}
                                    </div>
                                    <div class="filters4">
                                        <div class="filtersCont4">
                                            <div>
                                                <select class="custom-select" value={this.state.NumberofRecord} onChange={this.handleChange}>
                                                    <option value="0"  >All</option>
                                                    <option value="5" selected>5</option>
                                                    <option value="10">10</option>
                                                    <option value="50">50</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="paginationLRht">
                                        <a onClick={() => this.loadnxtdata("first")}><img src="./assets/img/icons/paginate-2-lft.png" /></a>
                                        <a class="" onClick={() => this.loadnxtdata("-")}><img src="./assets/img/icons/paginate-1-lft.png" /></a>
                                        <a class="" onClick={() => this.loadnxtdata("+")}><img src="./assets/img/icons/paginate-1-rht.png" /></a>
                                        <a onClick={() => this.loadnxtdata("last")} class="" ><img src="./assets/img/icons/paginate-2-rht.png" /></a>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div >

                {(!this.state.OrderData || this.state.OrderData.length == 0) && <div class="noOrders">
                    <img src="./assets/img/icons/sad.png" />
                    <h3>{t('lblnoorder')}</h3>
                    <p class="margin-bottom-20">{t('lblorderempty')}.</p>
                    <div class="formCont updateBtn">
                        <button onClick={() => { history.push("/") }}>{t('lblBuynow')}</button>
                    </div>
                </div>}
            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    const { OrderData } = state.accountReducer;
    return { user, appvariables, OrderData };
}
const mapActionToProps = {
    alertError: alertActions.error,
    GetOrderDel: accountActions.GetOrderDel,
    ViewTicket: gameActions.RePrintBetDel,
    GetReBetNumbers: gameActions.GetReBetNumbers
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(Order))